"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryTip = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../../helpers/getClassesPropType");

var _useStyles = require("../../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _SvgIconInfo = require("../../svg/feathers/SvgIconInfo");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c868c07ca{padding:1rem 1.25rem;color:var(--color-gray-90);display:grid;grid-template-columns:fit-content(100%) 1fr;grid-gap:.625rem;grid-gap:.625rem;gap:.625rem;grid-gap:.625rem;font-size:.875rem;font-weight:400;line-height:1.25rem}.c4d2571c3{display:flex;margin-top:.25rem}.ca57793b3{display:block;word-break:break-word}.cd34a1e80{background:var(--color-green-20)}.cd34a1e80 .c4d2571c3{color:var(--color-green-80)}.c9870a44e{background:var(--color-red-20)}.c9870a44e .c4d2571c3{color:var(--color-red-90)}.c1ddbcd08{background:var(--color-blue-20)}.c1ddbcd08 .c4d2571c3{color:var(--color-blue-90)}");
var styles = {
  root: 'c868c07ca',
  icon: 'c4d2571c3',
  content: 'ca57793b3',
  '--view-usual': 'cd34a1e80',
  '--view-warning': 'c9870a44e',
  '--view-info': 'c1ddbcd08'
};

var SecondaryTip = function SecondaryTip(props) {
  var children = props.children,
      classes = props.classes,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, /*#__PURE__*/_react.default.createElement(_SvgIconInfo.SvgIconInfo, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, children));
};

exports.SecondaryTip = SecondaryTip;
var view = ['usual', 'warning', 'info'];
SecondaryTip.modes = {
  view: view
};
SecondaryTip.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondaryTip.defaultProps = {
  classes: {},
  view: 'info'
};